import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=d1e776f2&scoped=true&"
import script from "./EditTag.vue?vue&type=script&lang=js&"
export * from "./EditTag.vue?vue&type=script&lang=js&"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=d1e776f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e776f2",
  null
  
)

component.options.__file = "EditTag.vue"
export default component.exports